import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSessionSnapshot } from "./permissions";

/**
 * Gate for everything except /signin. Keyed by business and branch, so switching remounts the whole tree
 * and no component state from the old context survives.
 */
export function RequireAuth() {
  const state = useSessionSnapshot();
  const location = useLocation();
  if (state.status !== "scoped") {
    return <Navigate to="/signin" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }
  return <Outlet key={`${state.businessId}:${state.branchId}`} />;
}
